"use strict";
import Pusher from "pusher-js";
import { channelAuthorizationWithCsrf } from "../pusher_csrf";
const CLUSTER = "mt1";
export function createPusherInstance() {
  return new Pusher(PusherConfig.apiKey, {
    cluster: CLUSTER,
    channelAuthorization: channelAuthorizationWithCsrf()
  });
}
